import { z } from "zod";
import { npdFormulationDtoSchema } from "../npd-formulation";
export const npdInitialGuessesHintDtoSchema = z.object({
    formulation: npdFormulationDtoSchema,
    parameters: z.record(z.number()),
});
